<script lang="ts">
  import SvelteMarkdown from 'svelte-markdown'

  import Icon from '$shared/icons/Icon.svelte';

  import CurationListItemGrip from '$comp/curations/CurationListItemGrip.svelte';

  export let addModalText = 'Add external link'
  export let addToCurationText = 'Add to Curation';
  export let contentTypeText = 'Content Type';
  export let curatableId: number;
  export let curatableType = '';
  export let descriptionLabel = 'Description';
  export let dropdownArticle = 'Article';
  export let dropdownAudio = 'Audio';
  export let dropdownLink = 'Link';
  export let dropdownSurvey = 'Survey/Poll';
  export let dropdownText = 'Text';
  export let dropdownVideo = 'Video';
  export let duration = '';
  export let editable: boolean = false;
  export let editModalText = 'Edit external link';
  export let estimatedDurationLabel = 'Estimated duration';
  export let externalUrl = '';
  export let href = '/';
  export let id = 0;
  export let is_nonexpert_path: boolean = false;
  export let itemDeleteConfirmationText = 'Are you sure you want to delete this item?';
  export let learning_objectives = '';
  export let learningObjectivesHeader = 'Learning Objectives';
  export let linkText = 'Link';
  export let optionalText = 'Optional';
  export let parent = 0;
  export let pasteUrlHereText = 'Paste URL here';
  export let path_color = null;
  export let path_icon = null;
  export let path_image = null;
  export let progress = '';
  export let requiredText = '*Required';
  export let saveChangesText = 'Save Changes';
  export let subhead = '';
  export let subeyebrow = '';
  export let thumbnail_url = '';
  export let title = '';
  export let titleLabel = 'Title';
  export let titlePlaceholder = 'Type here';
  export let type_overlay: 'Link' | 'Video' | 'Audio' | 'Article' | 'Survey/Poll' | string = 'Lesson';
  export let updateable: boolean = false;
  export let validUrlText = 'Links must begin with http:// or https:// and contain a valid suffix.';


  function handleDelete(parent: any, id: any) {
    const response = confirm(itemDeleteConfirmationText);

    let curationId = parent;
    let curationItemId = id;

    if (response == true) {
      fetch(`/curations/${curationId}/curated_items/${curationItemId}`, {
        method: "DELETE",
        credentials: "same-origin",
        // @ts-ignore
        headers: {
          "Content-Type": "application/json",
          // @ts-ignore
          "X-CSRF-Token": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
        }
      }).then(response => {
          if (response.ok) {
            const item = document.querySelector(`[data-id="${id}"]`);
            if (item) {
              item.remove();
          }
        }
      });
    } else {
      return;
    }
  }

  const externalLinkIcons = {
    link: 'Link',
    video: 'Play',
    audio: 'Headphones',
    article: 'FileText',
    'survey/poll': 'LayoutList',
  };

  $: iconName = curatableType === 'ExternalLink' ? externalLinkIcons[type_overlay?.toLowerCase()] : '';

  $: externalLinkTypeOverlays = [
    'Link',
    'Video',
    'Audio',
    'Article',
    'Survey/Poll',
  ].includes(type_overlay);

  const linkNavigation = (event) => {
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(href);
  };
</script>

<div data-id={id} data-parent={parent} class="relative flex flex-col gap-4 md:space-y-0 md:space-x-4 md:flex-row mt-4 w-full md:flex-shrink-0 md:mt-0 items-start">
  <div class="absolute z-10 right-[-1rem] top-0 h-full flex items-start p-2">
    {#if updateable}
      <div class="flex gap-4">
        {#if curatableType === 'ExternalLink'}
          <bt-modal-toggle
            role="button"
            tabindex="0"
            aria-haspopup="dialog"
            aria-controls="externalLinkModal"
            on:keydown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') (e.currentTarget).click();
            }}
            opensModal
            modalToToggle="externalLinkModal"
            modalData={btoa(JSON.stringify({
              mode: 'edit',
              curationId: parent,
              externalLinkId: curatableId,
              curatedItemId: id,
              addModalText,
              addToCurationText,
              contentTypeText,
              descriptionLabel,
              dropdownArticle,
              dropdownAudio,
              dropdownLink,
              dropdownSurvey,
              dropdownText,
              dropdownVideo,
              editModalText,
              estimatedDurationLabel,
              optionalText,
              linkText,
              pasteUrlHereText,
              requiredText,
              saveChangesText,
              titleLabel,
              titlePlaceholder,
              validUrlText,
            }))}
            on:click={(e) => {
              e.stopPropagation();
              const detail = { curationId: parent, externalLinkId: curatableId, curatedItemId: id };
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  document.dispatchEvent(new CustomEvent('external-link-edit-opened', {
                    detail, bubbles: true
                  }));
                });
              });
            }}
          >
            <button
              type="button"
              class="w-7 h-7 bg-white shadow-md p-1.5 transition-all rounded"
              aria-label="Edit link"
            >
              <Icon icon="SquarePen" size="small" />
            </button>
          </bt-modal-toggle>
        {/if}

        <button
          on:click|stopPropagation={() => handleDelete(parent, id)}
          class="w-7 h-7 bg-white shadow-md p-1.5 transition-all rounded handle">
          <Icon icon="Trash2" size="small" />
        </button>
      </div>
    {/if}
  </div>
  <div class="curation-list-item__card w-full md:w-3/4">
    {#if is_nonexpert_path}
      <div class="w-full md:w-1/2 curation-list-item__thumbnail-wrapper">
        <div class="content-card__thumbnail content-card__thumbnail--lp block aspect-w-16 aspect-h-9">
          <a href={href} style={`background-color: ${path_color}`}>
            <img src={path_image} alt={title} class="absolute inset-0 object-cover w-full h-full"/>
            <div class="absolute inset-y-0 right-0 left-[initial] h-full flex flex-col justify-center w-[28%] m-auto" style={`color: ${path_color}`}>
              <div class="h-[40px] w-[40px] sm:h-[20px] sm:w-[20px] lg:h-[30px] lg:w-[30px] xl:h-[40px] xl:w-[40px] mx-auto">
                {@html path_icon}
              </div>
            </div>
            <div class="curation-list-item__progress w-full h-2 bg-transparent absolute bottom-0">
              <div class="h-2 bg-yellow {progress}"></div>
            </div>
          </a>
        </div>
      </div>
      <CurationListItemGrip editable={editable}/>
    {:else}
      <div class="w-full md:w-1/2 curation-list-item__thumbnail-wrapper">
        <div class="content-card__thumbnail content-card__thumbnail--non-lp aspect-w-16 aspect-h-9 relative">
          <a href={href} on:click={linkNavigation}>
            {#if thumbnail_url}
              <img src={thumbnail_url} alt={title} class="object-cover"/>
            {:else if curatableType === 'ExternalLink' && iconName}
              <div class="flex h-full w-full items-center justify-center text-sky-blue bg-sky-blue-light">
                <Icon icon={iconName} size="large" />
              </div>
            {/if}
            <div class="curation-list-item__progress">
              <div class="h-2 bg-yellow {progress}"></div>
            </div>
          </a>
        </div>
      </div>
      <CurationListItemGrip editable={editable}/>
    {/if}
    <div class="w-full md:w-1/2">
      <div class="min-w-[100%] md:min-w-[30%] lg:pt-0 content-card__headline-stack">
        <div class="content-card__headline-stack__type">
          {type_overlay}
        </div>
        <a href={href} on:click={linkNavigation} class="content-card__headline-stack__headline line-clamp-3">
          {title}
        </a>

        {#if externalLinkTypeOverlays}
          <div class="flex max-w-full gap-1 text-sm text-neutral-500">
            <span class="shrink-0">URL:</span>
            <div class="truncate max-w-full">
              {externalUrl}
            </div>
          </div>
        {/if}
        <div class="content-card__expert">
          {subhead || ''}
          <span>
            <SvelteMarkdown source={subeyebrow} />
          </span>
        </div>
      </div>
      <div class="content-card__duration">
        <Icon icon="Clock" size="small"/><span>{duration}</span>
      </div>
    </div>
  </div>
  <div class="w-full md:w-1/4 curation-list-item__objectives">
    {#if learning_objectives}
      <span class="font-medium block mb-2">{learningObjectivesHeader}</span>
      <div class="curation-list-item__objectives__md">
        <SvelteMarkdown source={learning_objectives || ''} />
      </div>
    {/if}
  </div>
</div>

<style>
  .curation-list-item__card {
    display: flex;
    gap: theme('spacing.4');
    @media (max-width: theme('screens.md')) {

    }
    .content-card {
      height: max-content;
      display: block;
    }
  }
  .curation-list-item__thumbnail-wrapper {
    max-width: 30rem;
  }
  .content-card__thumbnail {
    position: relative;
  }
  .content-card__thumbnail--lp, .content-card__thumbnail--non-lp a {
    border: 1px solid transparent;
    &:hover {
      border: 1px solid black;
    }
  }
  .curation-list-item__progress {
    width: calc(100% + 2px);
    height: theme('spacing.2');
    position: absolute;
    bottom: 0;
    left: -1px;
  }

  .curation-list-item__card .content-card__expert {
    margin-top: theme('spacing.2');
    span {
      white-space: wrap;
    }
  }

  .curation-list-item__objectives {
    padding-right: theme('spacing.6');
  }

  :global(.curation-list-item__objectives .curation-list-item__objectives__md) {
      color: theme('colors.neutral.500');
  }

  :global(.curation-list-item__objectives ul) {
      list-style: initial;
  }

  :global(.curation-list-item__objectives li, .curation-list-item__objectives p) {
    display: list-item;
    list-style-type: disc;
    margin-left: 1rem;
  }
</style>
